export const AnalyticsConfig = isMobile => ({
  // eslint-disable-next-line
  domain: __ANALYTICS_DOMAIN_CLIENT__,
  profile: isMobile ? 'MOBILE' : 'DESKTOP'
});
